import $ from 'jquery'
import messageResource from '../messageResource'
import ListSelector from '../controls/ListSelector'
import {ReportGroupingLevel} from './constants'

export default function GroupingSelector()
{
    this.constructor = GroupingSelector;
}

GroupingSelector.ERROR_GROUPING_DUPLICATE = "errorGroupingDuplicate";
GroupingSelector.ERROR_DATES_AFTER_MONTHS = "errorDatesAfterMonths";
GroupingSelector.ERROR_DATES_AFTER_WEEKS = "errorDatesAfterWeeks";
GroupingSelector.ERROR_WEEKS_AFTER_MONTHS = "errorWeeksAfterMonths";
GroupingSelector.ERROR_INCORRECT_GROUPING_ORDER = "errorIncorrectGroupingOrder";

/**
 * Initializes selector
 * @param selectorId id of selector element
 * @param numberOfLevels - a number of grouping levels, 4 levels max
 * @param initialValues - an array containing initial values
 * @param changesCallback
 */
GroupingSelector.prototype.init = function(selectorId, numberOfLevels, initialValues, changesCallback)
{
    if (numberOfLevels < 1 || numberOfLevels > 4)
        throw "Number of levels in Grouping selector cannot be " + numberOfLevels;

    this.numberOfLevels = numberOfLevels;

    this.selectorId = selectorId;
    this.selectorEl = $("#" + this.selectorId);

    this.initListSelectors(numberOfLevels, initialValues, changesCallback);

    for (let r = numberOfLevels; r <= 4; r++)
        this.hideRow(r-1);

    this.updateTree();

    this.errorMessagesMap = {};
    this.errorMessagesMap[GroupingSelector.ERROR_GROUPING_DUPLICATE] = messageResource.getMessage("report.common.js.choose_grouping_opts");
    this.errorMessagesMap[GroupingSelector.ERROR_INCORRECT_GROUPING_ORDER] = messageResource.getMessage("report.form.choose_grouping_order_opts");
    this.errorMessagesMap[GroupingSelector.ERROR_DATES_AFTER_MONTHS] = messageResource.getMessage("report.common.js.grouping_dates_months");
    this.errorMessagesMap[GroupingSelector.ERROR_DATES_AFTER_WEEKS] = messageResource.getMessage("report.common.js.grouping_dates_weeks");
    this.errorMessagesMap[GroupingSelector.ERROR_WEEKS_AFTER_MONTHS] = messageResource.getMessage("report.common.js.grouping_weeks_months");

};

GroupingSelector.prototype.initListSelectors = function(numberOfLevels, initialValues, changesCallback)
{
    this.listSelectors = [];

    const self = this;
    for (let i=0; i<numberOfLevels; i++)
    {
        this.listSelectors[i] = this.initListSelector(i, initialValues[i], function() {
            self.onGroupingChange();
            if (changesCallback)
                changesCallback();
        });
    }
};

GroupingSelector.prototype.initListSelector = function(level, selectedValue, changesCallback)
{
    const listSelector = new ListSelector({
                                            renderTo: this.selectorEl.find("#" + this.selectorId + "_groupingLevel" + level)[0]
                                        });
    this.fillListSelector(listSelector, level);
    listSelector.on( "change", function () {
        if (changesCallback)
            changesCallback();
    });
    if ( selectedValue )
        listSelector.setActiveItemByValue( selectedValue, true );
    return listSelector;
};

GroupingSelector.prototype.fillListSelector = function(listSelector, level)
{
    // abstract
};

GroupingSelector.prototype.onGroupingChange = function()
{
    this.updateTree();
};

GroupingSelector.prototype.getListSelectorValue = function(number)
{
    return this.listSelectors[number].getSelectedItem().value;
};

GroupingSelector.prototype.updateTree = function()
{
    // abstract
};

GroupingSelector.prototype.validate = function()
{
    this.error = null;

    if (this.getNumberOfVisibleLevels() >= 2 && this.getListSelectorValue(0) === this.getListSelectorValue(1)
            && this.getListSelectorValue(1) !== ReportGroupingLevel.NONE)
    {
        this.error = GroupingSelector.ERROR_GROUPING_DUPLICATE;
        return false;
    }

    if (this.getNumberOfVisibleLevels() >= 3 && this.getListSelectorValue(2) !== ReportGroupingLevel.NONE &&
        (this.getListSelectorValue(0) === this.getListSelectorValue(2) ||
         this.getListSelectorValue(1) === this.getListSelectorValue(2)))
    {
        this.error = GroupingSelector.ERROR_GROUPING_DUPLICATE;
        return false;
    }

    return true;
};

GroupingSelector.prototype.verifyDateGroupingOrderFroTwoLevels = function()
{
    const firstLevelValue = this.getListSelectorValue(0);
    const secondLevelValue = this.getListSelectorValue(1);

    if( firstLevelValue === ReportGroupingLevel.DATE && secondLevelValue === ReportGroupingLevel.MONTH )
    {
        this.error = GroupingSelector.ERROR_DATES_AFTER_MONTHS;
        return false;
    }
    if( firstLevelValue === ReportGroupingLevel.DATE && secondLevelValue === ReportGroupingLevel.WEEK )
    {
        this.error = GroupingSelector.ERROR_DATES_AFTER_WEEKS;
        return false;
    }
    if( firstLevelValue === ReportGroupingLevel.WEEK && secondLevelValue === ReportGroupingLevel.MONTH )
    {
        this.error = GroupingSelector.ERROR_WEEKS_AFTER_MONTHS;
        return false;
    }

    return true;
};

GroupingSelector.prototype.getErrorMessage = function()
{
    return this.errorMessagesMap[this.error];
};

GroupingSelector.prototype.getValues = function()
{
    const selection = [];

    for (let i=0; i<this.getNumberOfVisibleLevels(); i++)
        selection.push(this.getListSelectorValue(i));

    return selection;
};

GroupingSelector.prototype.setValues = function(values)
{
    for (let i=0; i<values.length; i++)
        this.listSelectors[i].setActiveItemByValue(values[i]);
};

GroupingSelector.prototype.getRowEl = function(rowNumber)
{
    return this.selectorEl.find("#" + this.selectorId + "_treeRow" + (rowNumber + 1));
};

GroupingSelector.prototype.setRowClassName = function(rowNumber, className)
{
    this.getRowEl(rowNumber)[0].className = className;
};

GroupingSelector.prototype.addRowClassName = function(rowNumber, className)
{
    this.getRowEl(rowNumber).addClass(className);
};

GroupingSelector.prototype.removeRowClassName = function(rowNumber, className)
{
    this.getRowEl(rowNumber).removeClass(className);
};

GroupingSelector.prototype.hideRow = function(rowNumber)
{
    this.addRowClassName(rowNumber, "tree-row-hidden");
};

GroupingSelector.prototype.showRow = function(rowNumber)
{
    this.removeRowClassName(rowNumber, "tree-row-hidden");
};

GroupingSelector.prototype.getNumberOfVisibleLevels = function()
{
    return this.numberOfLevels;
};



// WEBPACK FOOTER //
// ./web/js/reports/GroupingSelector.js